let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("joJy8"), load("aHE9G"), load("1GyAj")]).then(() => parcelRequire('auDgK'));